export var AssetType;
(function (AssetType) {
    AssetType["EQ"] = "EQ";
    AssetType["UnlistedEquity"] = "UEQ";
    AssetType["FixedIncome"] = "FI";
    AssetType["CertOfDeposit"] = "COD";
    AssetType["CommPaper"] = "CP";
    AssetType["NCD"] = "NCD";
    AssetType["Warrant"] = "W";
    AssetType["Bonds"] = "BO";
    AssetType["Debentures"] = "DB";
    AssetType["IndianDepoReceipt"] = "IDR";
    AssetType["PreferenceShare"] = "PS";
    AssetType["CorpFD"] = "CFD";
    AssetType["RBIBonds"] = "RBO";
    AssetType["EC54"] = "54EC";
    AssetType["Derivatives"] = "FnO";
    AssetType["DEquity"] = "DEQ";
    AssetType["DCurrency"] = "DCU";
    AssetType["DCommodity"] = "DCO";
    AssetType["MP"] = "MAP";
    AssetType["Commodity"] = "SGB";
    AssetType["RealEstate"] = "RE";
    AssetType["ETF"] = "ETF";
    AssetType["MutualFund"] = "MF";
    AssetType["PMS"] = "PMS";
    AssetType["AIF"] = "AIF";
    AssetType["StructuredProducts"] = "SP";
    AssetType["INVITS"] = "INVITS";
    AssetType["Currency"] = "Currency";
    AssetType["CDS"] = "CDS";
    AssetType["CommodityCo"] = "CO";
})(AssetType || (AssetType = {}));
export var assetTypeMappingObj = {
    "Mutual Funds": { assetType: AssetType.MutualFund },
    ETF: { assetType: AssetType.ETF },
    AIF: { assetType: AssetType.AIF },
    PMS: { assetType: AssetType.PMS },
    INVITS: { assetType: AssetType.INVITS },
    "Structured Products": { assetType: AssetType.StructuredProducts },
    "Real Estate": { assetType: AssetType.RealEstate },
    Commodity: { assetType: AssetType.Commodity },
    "Fixed Income": { assetType: AssetType.FixedIncome },
    Derivatives: { assetType: AssetType.Derivatives },
    Equity: { assetType: AssetType.EQ },
};
export var TabMapping = [
    { title: "All", tabEventKey: "pnlAll", assetType: [] },
    {
        title: "Equity",
        tabEventKey: "equity",
        assetType: [AssetType.EQ, AssetType.UnlistedEquity],
    },
    {
        title: "Fixed Income",
        tabEventKey: "fixed-income",
        assetType: [
            AssetType.FixedIncome,
            AssetType.CertOfDeposit,
            AssetType.CommPaper,
            AssetType.NCD,
            AssetType.Warrant,
            AssetType.Bonds,
            AssetType.Debentures,
            AssetType.IndianDepoReceipt,
            AssetType.PreferenceShare,
            AssetType.CorpFD,
            AssetType.RBIBonds,
            AssetType.EC54,
        ],
    },
    {
        title: "Derivatives",
        tabEventKey: "derivative",
        assetType: [
            AssetType.Derivatives,
            AssetType.DEquity,
            AssetType.Currency,
            AssetType.DCommodity,
        ],
    },
    {
        title: "Managed Portfolios",
        tabEventKey: "mp",
        assetType: [
            AssetType.MP,
            AssetType.MutualFund,
            AssetType.ETF,
            AssetType.AIF,
            AssetType.PMS,
            AssetType.INVITS,
            AssetType.StructuredProducts,
        ],
    },
    {
        title: "Others",
        tabEventKey: "others",
        assetType: [AssetType.RealEstate, AssetType.Commodity],
    },
];
var PnLReportMainEntityContainer = /** @class */ (function () {
    function PnLReportMainEntityContainer(PnLData, SearchData, FilterData, SortData, IsSummarize) {
        this.PnLData = PnLData;
        this.SearchData = SearchData;
        this.FilterData = FilterData;
        this.SortData = SortData;
        this.IsSummarize = IsSummarize;
    }
    return PnLReportMainEntityContainer;
}());
export { PnLReportMainEntityContainer };
export var dynamicPNLFilters;
(function (dynamicPNLFilters) {
    dynamicPNLFilters["underlyingAsset"] = "Underlying Asset";
    dynamicPNLFilters["expiryMonth"] = "Expiry Month";
    dynamicPNLFilters["instrumentType"] = "Instrument Type";
    dynamicPNLFilters["optionType"] = "Option Type";
    dynamicPNLFilters["strikePrice"] = "Strike Price";
    dynamicPNLFilters["simpleFilter"] = "Filter By";
    dynamicPNLFilters["assetFilter"] = "Asset Filter";
    dynamicPNLFilters["Filter By"] = "Filter By";
})(dynamicPNLFilters || (dynamicPNLFilters = {}));
